import React from "react";
import { FaStar, FaUsers } from "react-icons/fa";
import Button from "../../components/EmptyButton";
import { BsArrowRight } from "react-icons/bs";

const CTASection = () => {
    return (
      <section className="py-20 bg-white w-[200px]">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto shadow-floating border-border/50 bg-gradient-card backdrop-blur-sm">
            <div className="py-12 text-left space-y-8">
              <div className="space-y-6">
              <h2
                style={{ fontSize: "3rem", fontWeight: "700", lineHeight: "1", paddingRight: '8px' }}
                className="font-bold text-foreground"
              >
                Join the movement of
                <span className="block text-primary">
                    26K+ StudyCrowd Members
                </span>
              </h2>
                <p style={{
                  color: "#78726d",
                  lineHeight: "1.625",
                  fontSize: "1.25rem",
                }}
                className="text-xl text-muted-foreground leading-relaxed">
                  Discover the secret to success as you become part of our growing community. 
                  Save time and study more efficiently with simple study materials from top graduates who took the same courses as you, personalized tutoring and career mentoring.
                </p>
              </div>
  
              {/* Social Proof */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" style={{ borderColor: "#f7f7f7" }}>
                <a 
                  href="https://www.reviews.co.uk/company-reviews/store/www.simplestudying.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ borderColor: "#f7f7f7" }}
                  className="flex items-center justify-center space-x-3 p-4 bg-white rounded-lg border border hover:bg-white transition-colors cursor-pointer"
                >
                  <FaStar className="w-6 h-6 text-primary" />
                  <div className="text-left">
                    <div className="font-bold text-foreground">4.6/5</div>
                    <div className="text-sm text-muted-foreground">Rating on Reviews.io</div>
                  </div>
                </a>
                
                <div style={{ borderColor: "#f7f7f7" }} className="flex items-center justify-center space-x-3 p-4 bg-white rounded-lg border">
                  <FaUsers className="w-6 h-6 text-primary" />
                  <div className="text-left">
                    <div className="font-bold text-foreground">26K+</div>
                    <div className="text-sm text-muted-foreground">Active Members</div>
                  </div>
                </div>
                
                <a 
                  href="https://g.co/kgs/94X3PU6"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ borderColor: "#f7f7f7" }}
                  className="flex items-center justify-center space-x-3 p-4 bg-white rounded-lg border border-white hover:bg-white transition-colors cursor-pointer"
                >
                  <FaStar className="w-6 h-6 text-primary" />
                  <div className="text-left">
                    <div className="font-bold text-foreground">4.9/5</div>
                    <div className="text-sm text-muted-foreground">Rating on Google</div>
                  </div>
                </a>
              </div>
  
              {/* CTA Buttons */}
              <div className="w-full flex justify-center">
                <div className="w-72">
                <Button
                filled={true}
                className="text-lg px-8 py-2"
                onClick={() =>
                  window.open("https://studycrowd.ai/login", "_blank")
                }
              >
                Get Started Today
                <BsArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
                </div>
            </div>
  
              <p className="text-sm text-muted-foreground">
                Free to join • No credit card required • Instant access
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  };
  
  export default CTASection;